import { all, put, takeLatest } from "@redux-saga/core/effects";
import { poi } from "../../data/data.json";
import { poi as coordinatesForFirstBuilding } from "../../data/coordinates-1.json";
import { poi as coordinatesForFirstBuildingMobile } from "../../data/coordinates-mobile.json";
import * as actionTypes from "../actionTaypes";
import { loadCoordinatesDone } from "../actions";


export function* watchCoordinates() {
  yield all([takeLatest(actionTypes.COORDINATES_LOAD_START, loadInitialCoordinates)]);
}

function* loadInitialCoordinates(action) {
  const { activeFloor, imgIndex, building } = action.payload;
  const floor = activeFloor.replace("floor-", "");
  let currentBuilding;
  let pois = poi;
  if (+building === 1) {
    if (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/iPhone/i)) {
      currentBuilding = coordinatesForFirstBuildingMobile;
    } else {
      currentBuilding = coordinatesForFirstBuilding;
    }
  }
  if (floor !== "all") {
    pois = pois.filter(poi => {
      return parseInt(poi.floor) === parseInt(floor);
    });
  }

  let pickUpCoordinates;
  let arrayOfPoisCoordinates = [];
  let arrayOfInfoCoordinates = [];

  pois.map(poi => {
    for (const coordinate in currentBuilding) {
      if (poi.lot === coordinate) {
        pickUpCoordinates = currentBuilding[coordinate].filter(item => {
          return item.hasOwnProperty(activeFloor);
        });

        if (pickUpCoordinates.length > 0) {
          pickUpCoordinates = pickUpCoordinates[0][activeFloor].filter(element => element["_img"] === imgIndex);
          if (pickUpCoordinates.length > 0) {
            arrayOfPoisCoordinates.push({ id: poi.id, coordinates: pickUpCoordinates[0] });
          }
        }
        break;
      }
    }
    return;
  });

  yield put(loadCoordinatesDone(arrayOfPoisCoordinates, arrayOfInfoCoordinates));
}
